import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Login from "./pages/login";
import Secure from "./pages/secure";
import "../src/assets/css/material-dashboard.css";
import "../src/assets/css/style-main.css";
// import "../src/assets/css/bootstrap.min.css";
// import "../src/assets/css/material-dashboard.css";
// import "../src/assets1/css/material-dashboard.css";
// // import "../src/assets/css/"

import "bootstrap/dist/js/bootstrap.js";
// import "https://kit.fontawesome.com/42d5adcbca.js";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router-dom";

import { logout } from "./redux/actions/auth";
import { toast } from "react-toastify";
import axios from "axios";
import "bootstrap/dist/js/bootstrap.js";
import "material-icons/iconfont/material-icons.css";

export var common_axios = axios.create({
  baseURL: "https://hrms-api.altruistindia.com/",
});

const App = (props) => {
  const Routes = props.auth ? Secure : Login;
  const { history } = props;

  axios.interceptors.request.use(
    (req) => {
      // console.log({ req });

      return req;
    },
    (err) => {
      // console.log(err);
      return Promise.reject(err);
    }
  );

  const token1 = localStorage.getItem("token");
  const uid = localStorage.getItem("UserId");
  common_axios.defaults.headers.common["Authorization"] = token1;
  // common_axios.defaults.headers.common["source"] = "web";
  common_axios.defaults.headers.common["UserId"] = uid;

  // axios.interceptors.response.use(
  //   (res) => {
  //     console.log({ res });

  //     if (
  //       res.request.responseURL == "http://192.168.167.66:5001/auth/v1/login" ||
  //       res.request.responseURL ==
  //         "http://192.168.167.66:5001/auth/v1/pin/verify"
  //     ) {
  //       if (res?.data?.statusDescription?.statusCode == 200) {
  //         localStorage.setItem(
  //           "token",
  //           res?.data?.userDetail?.userTokenDetails?.jwtToken
  //         );
  //         localStorage.setItem("UserId", res.data.userDetail.uid);
  //         const token1 = localStorage.getItem("token");
  //         const uid = localStorage.getItem("UserId");

  //         common_axios.defaults.headers.common["Authorization"] =
  //           "Bearer " + token1;
  //         common_axios.defaults.headers.common["UserId"] = uid;

  //         common_axios.defaults.headers.common["source"] = "web";
  //       }
  //     }

  //     if (
  //       res?.data?.statusDescription?.statusCode == 102 ||
  //       res?.data?.statusDescription?.statusCode == 303
  //     ) {
  //       localStorage.clear();
  //       setTimeout(() => {
  //         history.replace("/");
  //       }, 500);

  //       setTimeout(() => {
  //         toast.success(res.data.statusDescription.description, {
  //           theme: "colored",
  //         });
  //       }, 200);

  //       props.logout();
  //     }
  //     return res;
  //   },
  //   (err) => {
  //     console.log(err);
  //     return Promise.reject(err);
  //   }
  // );

  common_axios.interceptors.response.use(
    (res) => {
      if (
        res?.data?.statusDescription?.statusCode == 102 ||
        res?.data?.statusDescription?.statusCode == 303
      ) {
        localStorage.clear();
        history.replace("/");

        setTimeout(() => {
          toast.success(res.data.statusDescription.description, {
            theme: "colored",
          });
        }, 200);
      }
      return res;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
  useEffect(() => {
    if (localStorage?.getItem("token")) {
      history.listen((newLocation, action) => {
        if (action === "PUSH") {
          if (
            newLocation.pathname !== this.currentPathname ||
            newLocation.search !== this.currentSearch
          ) {
            // Save new location
            this.currentPathname = newLocation.pathname;
            this.currentSearch = newLocation.search;

            // Clone location object and push it to history
            history.push({
              pathname: newLocation.pathname,
              search: newLocation.search,
            });
          }
        } else {
          // Send user back if they try to navigate back
          history.go(1);
        }
      });
    }
  }, [localStorage?.getItem("token")]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     console.clear();
  //   }, 500);
  // }, []);
  // console.log(props.location.pathname);

  return <Routes />;
};

const mapStateToProps = (state) => ({
  auth: state.authReducer.auth,
});

// const mapDispatchToProps = {};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
